import axios from 'axios';

export default {
  getTemplateCollection(): Promise<any> {
    return axios.get(
      process.env.VUE_APP_BASCLOUD_REFERENCE_SERVER_URL + '/templates'
    );
  },
  getSingleDataCollection(
    tenantUUID: string,
    templateUUID: string,
    entityId: string,
    params = {}
  ): Promise<any> {
    return axios.get(
      process.env.VUE_APP_BASCLOUD_REFERENCE_SERVER_URL +
        '/tenants/bascloud/' +
        tenantUUID +
        '/data/' +
        templateUUID +
        '/' +
        entityId
    );
  },
  getSingleDataHistory(
    tenantUUID: string,
    templateUUID: string,
    entityId: string,
    params = {}
  ): Promise<any> {
    return axios.get(
      process.env.VUE_APP_BASCLOUD_REFERENCE_SERVER_URL +
        '/tenants/bascloud/' +
        tenantUUID +
        '/data/' +
        templateUUID +
        '/' +
        entityId +
        '/history'
    );
  },

  async getAllDataCollectionPages(
    tenantUUID: string,
    params: any = {}
  ): Promise<any> {
    const requests = [];
    let currentPage = 1;
    let nextPageLink = null;

    do {
      let requestURL =
        process.env.VUE_APP_BASCLOUD_REFERENCE_SERVER_URL +
        '/tenants/bascloud/' +
        tenantUUID +
        '/data?';

      for (const param in params) {
        requestURL += param;
        requestURL += '=';
        requestURL += params[param];
        requestURL += '&';
      }
      if (nextPageLink) {
        requestURL =
          process.env.VUE_APP_BASCLOUD_REFERENCE_SERVER_URL + nextPageLink;
      }

      const response: Promise<any> = axios.get(requestURL);

      if (nextPageLink) {
        const results: any = await response;
        nextPageLink = results.data?.links?.next ?? undefined;
      }
      requests.push(response);
      currentPage++;
    } while (nextPageLink);

    return Promise.all(requests);
  },
  createData(
    tenantUUID: string,
    templateUUID: string,
    entityType: string,
    payload: object
  ): Promise<any> {
    const body = {
      data: {
        type: 'data',
        attributes: {
          entityType,
          payload,
        },
      },
    } as any;

    return axios.post(
      process.env.VUE_APP_BASCLOUD_REFERENCE_SERVER_URL +
        '/tenants/bascloud/' +
        tenantUUID +
        '/data/' +
        templateUUID,
      JSON.stringify(body),
      { headers: { 'Content-Type': 'application/json' } }
    );
  },
  addData(
    tenantUUID: string,
    templateUUID: string,
    entityId: string,
    entityType: string,
    payload: object
  ): Promise<any> {
    const body = {
      data: {
        type: 'data',
        attributes: {
          entityType,
          payload,
        },
      },
    } as any;

    return axios.post(
      process.env.VUE_APP_BASCLOUD_REFERENCE_SERVER_URL +
        '/tenants/bascloud/' +
        tenantUUID +
        '/data/' +
        templateUUID +
        '/' +
        entityId,
      JSON.stringify(body),
      { headers: { 'Content-Type': 'application/json' } }
    );
  },
  updateData(
    tenantUUID: string,
    templateUUID: string,
    entityId: string,
    payload: object
  ): Promise<any> {
    const body = {
      data: {
        type: 'data',
        id: entityId,
        attributes: {
          payload,
        },
      },
    } as any;

    return axios.patch(
      process.env.VUE_APP_BASCLOUD_REFERENCE_SERVER_URL +
        '/tenants/bascloud/' +
        tenantUUID +
        '/data/' +
        templateUUID +
        '/' +
        entityId,
      JSON.stringify(body),
      { headers: { 'Content-Type': 'application/json' } }
    );
  },
  deleteData(
    tenantUUID: string,
    templateUUID: string,
    entityId: string
  ): Promise<any> {
    return axios.delete(
      process.env.VUE_APP_BASCLOUD_REFERENCE_SERVER_URL +
        '/tenants/bascloud/' +
        tenantUUID +
        '/data/' +
        templateUUID +
        '/' +
        entityId
    );
  },
  getUserPermissions(userUUID: string) {
    return axios.get(
      process.env.VUE_APP_BASCLOUD_REFERENCE_SERVER_URL +
        '/permissions?filter.identifier=string.eq.' +
        userUUID
    );
  },
  addUserPermission(
    tenantUUID: string,
    userUUID: string,
    entityType: string,
    permission: string,
    filter: object
  ) {
    const body = {
      data: {
        type: 'permissions',
        attributes: {
          entityType: entityType,
          identifier: userUUID,
          service: 'bascloud',
          permission: permission,
          tenant: {
            identifier: tenantUUID,
            service: 'bascloud',
          },
          filter: filter,
        },
      },
    } as any;

    return axios.post(
      process.env.VUE_APP_BASCLOUD_REFERENCE_SERVER_URL + '/permissions',
      JSON.stringify(body),
      { headers: { 'Content-Type': 'application/json' } }
    );
  },
  deleteUserPermissions(permissionUUID: string) {
    return axios.delete(
      process.env.VUE_APP_BASCLOUD_REFERENCE_SERVER_URL +
        '/permissions/' +
        permissionUUID
    );
  },
};
